<template>
  <div class="d-flex align-items-center">
    <span>{{ leistungskuerzel }}</span>
    <span
      v-if="zeigePlus"
      class="storno-plus ml-2"
      v-b-tooltip.hover="{ title: 'Weitere Stornozeile erstellen', customClass: 'tooltip-class' }"
      @click.stop="onPlusClick"
    >
      <CirclePlus :size="16" />
    </span>
  </div>
</template>

<script>
import { CirclePlus } from 'lucide-vue';

export default {
  name: 'CellRendererLeistungskuerzelStorno',
  components: { CirclePlus },
  computed: {
    cellParams() {
      return this.params ?? this.$attrs.params;
    },
    leistungskuerzel() {
      const value = this.cellParams?.data?.leistungskuerzel;
      return value == null || value === '' ? '-' : value;
    },
    zeigePlus() {
      const canDuplizieren = this.cellParams?.canDuplizieren;
      if (typeof canDuplizieren !== 'function') return false;
      return canDuplizieren(this.cellParams?.data) === true;
    },
  },
  methods: {
    onPlusClick() {
      const onStornoDuplizieren = this.cellParams?.onStornoDuplizieren;
      const data = this.cellParams?.data;
      if (typeof onStornoDuplizieren === 'function' && data) {
        onStornoDuplizieren(data);
      }
    },
  },
};
</script>

<style scoped>
.storno-plus {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #dc3545;
  cursor: pointer;
}
</style>

<style>
.tooltip-class.tooltip {
  opacity: 1;
}
</style>
